/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_VoiceInputs */

const en_pricing_feature_voice = /** @type {(inputs: Pricing_Feature_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your voice and playback speed`)
};

const es_pricing_feature_voice = /** @type {(inputs: Pricing_Feature_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige la voz y la velocidad de reproducción`)
};

/**
* | output |
* | --- |
* | "Choose your voice and playback speed" |
*
* @param {Pricing_Feature_VoiceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_voice = /** @type {((inputs?: Pricing_Feature_VoiceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_VoiceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_feature_voice(inputs)
	return en_pricing_feature_voice(inputs)
});